import { createTheme } from '@mui/material';

const theme = createTheme({
    typography: {
        fontFamily: `'Montserrat', sans-serif`,
    },
    breakpoints: {
        values: {
            laptop: 1440,
        },
    },
    palette: {
        mode: 'light',
        primary: {
            main: '#178A7B',
            dark: '#146F62',
            light: '#A2CBF4',
            black: '#000000',
            se100: '#CCEFFF',
            se700: '#006999',
        },
        gray: {
            main: '#707070',
            dark: '#146F62',
            light: '#A2CBF4',
            shade100: '#F3F4F6',
            shade300: '#D1D5DC',
            shade400: '#99A1AF',
        },
    },
    fontFamily: 'Montserrat',
    components: {
        MuiTypography: {
            styleOverrides: {
                root: ({ theme }) => ({
                    h1: {
                        fontSize: '32px',
                    },
                }),
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '& .MuiTablePagination-selectLabel': {
                        textTransform: 'capitalize',
                    },
                    '& .MuiTablePagination-displayedRows': {
                        textTransform: 'lowercase',
                    },
                }),
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
                        padding: '0rem',
                    },
                }),
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    '& .MuiMenu-list': {
                        display: 'flex !important',
                        flexDirection: 'column !important',
                    },
                    '& .MuiButtonBase-root': {
                        justifyContent: 'start !important',
                        paddingLeft: '1rem !important',
                    },
                },
            },
        },
    },
});

export default theme;
